export default "__VITE_ASSET__Dk5_5Kz7__"